import { Button, Checkbox, Tag } from '@maxtropy/components';
import styles from './index.module.scss';

export type FurnaceType = 'calcium-carbide' | 'ferrosilicon';

export interface FurnaceItem {
  id: number;
  name: string;
  code: string;
  type: FurnaceType;
}

interface FurnaceSelectorProps {
  value?: number[];
  onChange?: (value: number[]) => void;
  furnaces: FurnaceItem[];
  loading?: boolean;
}

const FurnaceSelector = ({ value = [], onChange, furnaces, loading }: FurnaceSelectorProps) => {
  const selectedIds = value;

  const selectByType = (type: FurnaceType) => {
    onChange?.(furnaces.filter(item => item.type === type).map(item => item.id));
  };

  const toggleFurnace = (id: number, checked: boolean) => {
    onChange?.(checked ? [...new Set([...selectedIds, id])] : selectedIds.filter(item => item !== id));
  };

  return (
    <div className={styles.selectorWrapper}>
      <div className={styles.selectedSummary}>
        <strong>
          已选 <b>{selectedIds.length}</b> 台
        </strong>
        <span>建议与“可调范围/升降速度/禁调条件”联动校验（超限拦截）</span>
      </div>

      <div className={styles.selectorPanel}>
        <div className={styles.selectorHeader}>
          <div>
            <strong>炉台列表</strong>
            <span>（共{furnaces.length}台）</span>
          </div>
          <div className={styles.selectorActions}>
            <Button
              type="link"
              htmlType="button"
              disabled={loading}
              onClick={() => onChange?.(furnaces.map(item => item.id))}
            >
              全选
            </Button>
            <Button type="link" htmlType="button" disabled={loading} onClick={() => selectByType('calcium-carbide')}>
              仅电石炉
            </Button>
            <Button type="link" htmlType="button" disabled={loading} onClick={() => selectByType('ferrosilicon')}>
              仅硅铁炉
            </Button>
            <Button type="link" htmlType="button" disabled={loading} onClick={() => onChange?.([])}>
              清空
            </Button>
          </div>
        </div>

        <div className={styles.deviceGrid}>
          {furnaces.map(item => (
            <div className={styles.deviceItem} key={item.id}>
              <Checkbox
                checked={selectedIds.includes(item.id)}
                onChange={event => toggleFurnace(item.id, event.target.checked)}
              />
              <span className={styles.deviceName}>{item.name}</span>
              <Tag
                border="solid"
                color={item.type === 'calcium-carbide' ? '#52E7FF' : '#FAAD14'}
                className={styles.typeTag}
              >
                {item.type === 'calcium-carbide' ? '电石炉' : '硅铁炉'}
              </Tag>
              <span className={styles.deviceCode}>{item.code}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FurnaceSelector;
